import moment from 'moment-timezone';

export const DATE_FORMAT = 'YYYY-MM-DD';
export const RESERVATION_DATE_FORMAT = 'DD-MM-YYYY';
export const LONG_DATE_FORMAT = 'DD MMM YYYY';
export const LONG_MONTH_FORMAT = 'MMMM DD, YYYY';
export const SHORT_DATE_TIME_FORMAT = 'DD MMM - LT';
export const CALENDAR_DATE_FORMAT = 'YYYY-MM-DD';
export const TIME_FORMAT = 'LT';
export const LONG_MONTH_NAME_FORMAT = 'DD MMM YYYY';
export const APPOINTMENT_DATE_TIME_FORMAT = 'DD.MM.YYYY HH:mm';
export const APPOINTMENT_DATE_RANGE_FORMAT = 'DD.MM.YYYY';
export const APPOINTMENT_WEEK_DATE_TIME_FORMAT = 'ddd , DD MMMM YYYY';
export const CALENDAR_DATE_TIME_FORMAT = 'dd/MM/yyyy';
export const DATE_OF_BIRTH_TIME_FORMAT = 'dd MMMM yyyy';
export const YEAR_FORMAT = 'yyyy';

export const LAST_DAY_NEXT_MONTH = moment().add(1, 'M').endOf('month');

export function formatDate(value: moment.MomentInput) {
  if (!value) {
    return '';
  }
  return moment(value).format(DATE_FORMAT);
}

export function formatLongDate(value: moment.MomentInput) {
  if (!value) {
    return '';
  }
  return moment(value).format(LONG_DATE_FORMAT);
}

export function formatTime(value: moment.MomentInput) {
  if (!value) {
    return '';
  }
  return moment(value).format(TIME_FORMAT);
}

export function formatShortDateTime(value: moment.MomentInput) {
  if (!value) {
    return '';
  }
  return moment(value).format(SHORT_DATE_TIME_FORMAT);
}

export function formatAppointmentDateTime(value: moment.MomentInput) {
  if (!value) {
    return '';
  }
  return moment(value).format(APPOINTMENT_DATE_TIME_FORMAT);
}

export function formatAppointmentDateRange(value: moment.MomentInput) {
  if (!value) {
    return '';
  }
  return moment(value).format(APPOINTMENT_DATE_RANGE_FORMAT);
}

export function formatYear(value: moment.MomentInput) {
  if (!value) {
    return '';
  }
  return moment(value).format(YEAR_FORMAT);
}

export function convertDMYToYMD(value: string = '') {
  const dateMm = moment(value, RESERVATION_DATE_FORMAT);
  if (!dateMm.isValid()) {
    return '';
  }
  return dateMm.format(DATE_FORMAT);
}

export function checkYMDIsValid(value: string = '') {
  const dateMm = moment(value, DATE_FORMAT);
  if (!dateMm.isValid()) {
    return '';
  }
  return value;
}
